import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IBusinessAdditionalInfoProps } from '../state/business-config/business-config.reducer';

@Injectable()
export class OnboardingUtilsService {
  destroyed$ = new Subject<boolean>();
  translations: any;
  constructor(
    private alertCtrl: AlertController,
    private translate: TranslateService
  ) {
    setTimeout(() => {
      this.translate
        .get(['ACTIONS', 'ONBOARDING_MODULE'])
        .pipe(takeUntil(this.destroyed$))
        .subscribe((t) => (this.translations = t));
    }, 800);
  }

  async confirmLeaveWizard(cb: () => void, message?: string) {
    const alert = await this.alertCtrl.create({
      header:
        this.translations.ONBOARDING_MODULE.MODULES_LIST.goToBoxxALERT.header,
      message:
        message ||
        this.translations.ONBOARDING_MODULE.MODULES_LIST.goToBoxxALERT.message,
      buttons: [
        {
          text: this.translations.ACTIONS.cancel,
          cssClass: 'boxx-main-btn',
        },
        {
          text: this.translations.ACTIONS.exit,
          handler: () => {
            cb();
          },
        },
      ],
    });

    alert.present();
  }

  async confirmConfigureLater(cb: () => void) {
    const alert = await this.alertCtrl.create({
      header: this.translations.ACTIONS.goToBoxx,
      message:
        this.translations.ONBOARDING_MODULE.MODULES_LIST.exitConfigurationALERT
          .message,
      buttons: [
        {
          text: this.translations.ACTIONS.cancel,
        },
        {
          text: this.translations.ACTIONS.exit,
          handler: () => {
            cb();
          },
          cssClass: 'boxx-main-btn',
        },
      ],
    });

    alert.present();
  }

  getBusinessConfigNexStep(
    businessConfigState: IBusinessAdditionalInfoProps,
    currentStep: BusinessConfigStepNames
  ) {

    const steps: { [key: string]: BusinessConfigStepNames } = {
      services: 'services',
      schedule: 'schedule',
      paymentMethods: 'payments',
      socialNetworks: 'social',
      gmbStatus: 'gmb-status',
      notifications: 'notifications',
      website: 'website',
    };

    let nextStep = 'onboarding/business-configuration/config-';

    let currentStepFound = currentStep === 'NONE' ? true : false;

    const hasNextStep = Object.keys(steps).some((key) => {
      if (!businessConfigState[key].completed && currentStepFound) {
        nextStep += steps[key];
        return true;
      }
      if (!currentStepFound) {
        currentStepFound = steps[key] === currentStep;
      }
      return null;
    });

    if (!hasNextStep) {
      nextStep = 'onboarding/business-configuration/config-finished';
    }

    return nextStep;
  }
}

export type BusinessConfigStepNames =
  | 'services'
  | 'schedule'
  | 'payments'
  | 'social'
  | 'gmb-status'
  | 'notifications'
  | 'website'
  | 'NONE';
